import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OkeeyCashSlideService } from '../core/services/okeey-cash-slide.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'core/services/auth.service';
import { User } from 'shared/types/user.model';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-apply-to-okeey-cash',
  templateUrl: './apply-to-okeey-cash.component.html',
  styleUrl: './apply-to-okeey-cash.component.scss',
  standalone: true,
  imports: [GoBackComponent, TranslateModule, KorviuButtonComponent]
})
export class ApplyToOkeeyCashComponent {
  public get currentUser(): User {
    return this._authService.currentUser;
  }
  public okeeyCash: any[] = [
    {
      imgSrc: 'assets/img/my-okeey-cash/language.svg',
      title: 'okeeyCash.language',
      description: 'okeeyCash.languageDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/location.svg',
      title: 'okeeyCash.tutorial.accessPermission',
      description: 'okeeyCash.tutorial.accessPermissionSubText'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/referral-code.svg',
      title: 'okeeyCash.referralCode',
      description: 'okeeyCash.referralCodeDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/mobile-number.svg',
      title: 'okeeyCash.mobileNumber',
      description: 'okeeyCash.mobileNumberDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/id-documents.svg',
      title: 'okeeyCash.idDocument.title',
      description: 'okeeyCash.idDocumentDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/selfie-time.svg',
      title: 'okeeyCash.selfieTime',
      description: 'okeeyCash.selfieTimeDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/personal-detail.svg',
      title: 'okeeyCash.personalDetail',
      description: 'okeeyCash.personalDetailDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/us-address.svg',
      title: 'okeeyCash.usAddress.title',
      description: 'okeeyCash.usAddressDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/your-password.svg',
      title: 'okeeyCash.yourPassword',
      description: 'okeeyCash.yourPasswordDescription'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/terms-&-condition.svg',
      title: 'okeeyCash.termsAndCondition',
      description: 'okeeyCash.termsAndConditionDescription'
    }
  ];
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _okeeyCashSlideService: OkeeyCashSlideService,
    private _authService: AuthService,
    private _translateService: TranslateService
  ) {}

  public navigateToTutorial(index: number) {
    this._okeeyCashSlideService.selectedIndex = index;
    this._router.navigate(['tutorial'], { relativeTo: this._route.parent });
  }

  public goToTutorial() {
    this._okeeyCashSlideService.selectedIndex = 0;
    this._router.navigate(['tutorial'], { relativeTo: this._route.parent });
  }

  public goToOkeeyCash(): void {
    const referralId: number = this.currentUser.id;
    const link: string = `https://usa.okeeycash.com/web/UNIGANA?externalReferenceCode=${referralId}`;
    window.open(link, '_blank');
  }
}
